import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage, defineMessages, IntlShape} from 'react-intl';

const messages = defineMessages({
    missingScenariosSubject: {id: 'webScenarios.missingScenariosSubjectNew', 'defaultMessage': 'Missing scenario for combination of {applications}.'},
    whatThisScenarioShouldDo: {id: 'webScenarios.whatThisScenarioShouldDo2', 'defaultMessage': 'What should this scenario do?'},
    andJoin: {id: 'common.andJoin', 'defaultMessage': '{one} and {two}'},
    commaJoin: {id: 'common.commaJoin', 'defaultMessage': '{one}, {two}'},
});

import './scenarios.scss';

interface NoScenariosMailProps {
 intl?: object;
 selectedApplications?: unknown[];
}

class NoScenariosMail extends React.Component<NoScenariosMailProps> {
    static propTypes = {
        intl: PropTypes.object,
        selectedApplications: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {
            applicationList: this.generateApplicationList(props.selectedApplications || [])
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.selectedApplications) {
            this.setState({
                applicationList: this.generateApplicationList(nextProps.selectedApplications || [])
            });
        }
    }

    generateApplicationList(applications = []) {
        let appCnt = applications.length;

        return applications
            .filter(item => !!item)
            .map(app => app.name)
            .sort((a, b) => a.localeCompare(b))
            .reduce((accumulator, currentValue, currentIndex) => {
                if (currentIndex === 0) {
                    return currentValue;
                }
                if (currentIndex === appCnt - 1) {
                    return this.props.intl.formatMessage(messages.andJoin, {one: accumulator, two: currentValue});
                }

                return this.props.intl.formatMessage(messages.commaJoin, {one: accumulator, two: currentValue});
            }, '');
    }

    getMailtoMissingScenario() {
        return 'mailto:support@dativery.com?'
            + 'subject=' + this.props.intl.formatMessage(messages.missingScenariosSubject, {applications: this.state.applicationList})
            + '&body=' + this.props.intl.formatMessage(messages.whatThisScenarioShouldDo);
    }

    render() {
        return (
            <div className="empty">
                <div><FormattedMessage defaultMessage="No matching scenarios for combination of {applications}." id="scenarioFinder.noMatchingScenarioNew" values={{applications: this.state.applicationList}} /></div>
                <a className="btn btn-primary" href={this.getMailtoMissingScenario()} type="button">
                    <FormattedMessage defaultMessage="Tell us what is missing here" id="scenarioFinder.telUs" />
                </a>
            </div>
        );
    }
}

export default injectIntl(NoScenariosMail);
